import { createFileRoute } from "@tanstack/react-router"
import { OrganizationDetail } from "@/components/organizations"
import { AppLogger } from '@/lib/logger'

const log = AppLogger.getLogger(import.meta)

export const Route = createFileRoute("/organizations/$organizationNumber/")({
  staticData: {
    title: 'Organization Detail',
    isSecured: true,
  },
  component: OrganizationDetailPage,
})

function OrganizationDetailPage() {
  const { organizationNumber } = Route.useParams()

  return (
    <div className="p-6">
      <OrganizationDetail organizationId={parseInt(organizationNumber)} />
    </div>
  )
}
